export default __webpack_public_path__ + "static/media/qrcode.effb0c10.svg";